
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/import/shop",
      function () {
        return require("private-next-pages/import/shop.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/import/shop"])
      });
    }
  